import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

export interface CtntCategoryMenuItem {
  Link: string;
  Txt: string;
  Code: string;
}

interface CtntCategoryMenuProps {
  menus: CtntCategoryMenuItem[];
  activeCode: string;
  className?: string;
  onPageChange?: (page: number) => void;
  onSelect?: (code: string) => void;
}

const CtntCategoryMenu: React.FC<CtntCategoryMenuProps> = ({ menus, activeCode, className, onPageChange, onSelect }) => {
  const [selectedCode, setSelectedCode] = useState<string | undefined>(activeCode);

  useEffect(() => {
    setSelectedCode(activeCode);
  }, [activeCode]);

  return (
    <div className={className ? className : "ctntCtgrMenu"}>
    {/* <div className={className ? className : "ctntCtgrMenu"} style={{ display: menus.length <= 1 ? "none" : undefined }}> */}
      <ul>
        {menus.map((menu) => {
          const isInternal = typeof menu.Link === 'string' && menu.Link.startsWith('/');
          return (
            <li key={menu.Code} className={selectedCode === menu.Code ? "active" : ""}>
              {isInternal ? (
                <Link
                  to={menu.Link}
                  onClick={() => {
                    setSelectedCode(menu.Code);
                    if (onSelect) {
                      onSelect(menu.Code);
                    } else if (onPageChange) {
                      onPageChange(1);
                    }
                  }}
                >
                  <p>{menu.Txt}</p>
                </Link>
              ) : (
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setSelectedCode(menu.Code);
                    if (onSelect) {
                      onSelect(menu.Code);
                    } else if (onPageChange) {
                      onPageChange(1);
                    }
                  }}
                >
                  <p>{menu.Txt}</p>
                </a>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default CtntCategoryMenu;
